import { render, staticRenderFns } from "./Abonements.vue?vue&type=template&id=34da59c4&scoped=true&lang=pug&"
import script from "./Abonements.vue?vue&type=script&lang=js&"
export * from "./Abonements.vue?vue&type=script&lang=js&"
import style0 from "./Abonements.vue?vue&type=style&index=0&id=34da59c4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34da59c4",
  null
  
)

/* custom blocks */
import block0 from "./Abonements.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports